type FaqType = {
  question: string;
  answer: string | string[];
};

const faqList: FaqType[] = [
  {
    question: 'What types of tickets are there?',
    answer:
      'There are three types of tickets in the game:<1/>Silver — basic<1/>Gold — advanced<1/>Diamond — rare and the most valuable<1/>Each ticket type enters its own draw level with a different prize pool.',
  },
  {
    question: 'When are the draws held?',
    answer:
      'Draws are held on a fixed schedule — check the timers in the Ticket Draw section<1/>Silver: every Friday at 16:15 UTC<1/>Gold: every Friday at 16:30 UTC<1/>Diamond: once per season (every 4 weeks) on Friday at 17:00 UTC',
  },
  {
    question: 'How can I get Silver tickets?',
    answer: [
      'By completing free special contracts (Premium, Grand, Blitz).',
      "In certain seasons, by placing high on the Arena leaderboard, if Silver tickets are listed in the current season's reward pool.",
      'By completing the «Daily Goods» quest (free Spin).',
    ],
  },
  {
    question: 'How can I get Gold tickets?',
    answer: [
      'By completing paid special contracts (Premium, Grand, Blitz).',
      "In certain seasons, by placing high on the Arena leaderboard, if Gold tickets are listed in the current season's reward pool.",
      'By completing the «Daily Goods» quest (free Spin) with an active VIP status.',
      'By completing the «Daily Goods» quest (paid Spin).',
    ],
  },
  {
    question: 'How can I get Diamond tickets?',
    answer: [
      'A chance to drop when completing the “Daily Goods” quest (paid Spin).',
      "In certain seasons, Diamond tickets may be awarded for high Arena placements, if stated in the current season's reward table.",
      'Diamond tickets may be awarded as an additional reward together with USD in both Silver and Gold draws.',
      'Diamond tickets may be awarded as a consolation reward in Gold and Diamond draws if:<1/>• you did not win USD<1/>• you collected the required number of tickets listed in the consolation rewards table.',
    ],
  },
  {
    question: 'What is a ticket ID?',
    answer:
      "The ID code on a ticket shows where it came from (for example, a contract or the Arena), while the last 5 characters act as the ticket„s unique «passport» to ensure a fair draw.<1/>No need to worry about the technical details — i's there to guarantee fairness!",
  },
  {
    question: 'What happens to tickets after the draw?',
    answer:
      'Once a draw is completed, all tickets that took part are no longer valid for future draws. Players holding winning tickets receive their corresponding rewards.',
  },
  {
    question: 'What can I win in a draw?',
    answer:
      'Possible rewards include:<1/>— USD (credited to your balance and available for withdrawal)<1/>— T-GEM (in-game currency)<1/>— Diamond tickets',
  },
  {
    question: 'Can I win multiple prizes at once?',
    answer:
      "Yes! You'll receive a reward for each winning ticket you have. Winners are selected completely at random, so luck can strike multiple times.<1/>The more tickets you have, the higher your chances of winning!",
  },
  {
    question: "Do participants get anything if they don't win?",
    answer:
      "Players who don't win any prizes but hold 1 or more tickets of the corresponding type still receive a consolation reward in the form of in-game goodies:)",
  },
];

export { faqList };
